import type { HomePageType } from '~/common/model/identity';

/** Home Page. */
export const HOME_PAGE_MAPPING: Record<HomePageType, string> = {
  batch: `/batch/new`,
  workQueue: `/work-queue`,
};

/** Home pages. */
export const HOME_PAGES = Object.keys<HomePageType>(HOME_PAGE_MAPPING);

export const ImageType: string[] = ['image/jpeg', 'image/png', 'image/webp'];
